var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.004 10.689 2.43-2.541a.59.59 0 0 1 .878 0 .653.653 0 0 1 .188.467c0 .18-.063.336-.188.467l-2.414 2.54c-.24.252-.539.378-.894.378s-.653-.126-.893-.377L.68 9.082a.625.625 0 0 1-.18-.467.683.683 0 0 1 .195-.467.598.598 0 0 1 .447-.197c.173 0 .321.065.447.197l2.414 2.54zm0-9.378L1.59 3.836a.562.562 0 0 1-.44.189.647.647 0 0 1-.438-.189.683.683 0 0 1-.196-.467.625.625 0 0 1 .18-.467L3.111.377C3.35.126 3.649 0 4.004 0s.653.126.894.377l2.414 2.525a.625.625 0 0 1 .18.467.683.683 0 0 1-.196.467.647.647 0 0 1-.439.189.562.562 0 0 1-.439-.189L4.004 1.311z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableExpand);
export default __webpack_public_path__ + "static/media/table-expand.ef649f9a3a59125ffac54d51441d6011.svg";
export { ForwardRef as ReactComponent };